module.exports = __webpack_public_path__ + "box_m.png?2aede926e68618547093b24bc4f02455";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/box_m.png
// module id = 86
// module chunks = 0